module.exports = __webpack_public_path__ + "img/text.05c7af0f.png";